module.exports = __webpack_public_path__ + "static/media/others.38eb492b.png";